import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

const Icon = ({ open }) => (
  <FontAwesomeIcon
    className="inline w-4 h-4 pr-1"
    icon={open ? faChevronUp : faChevronDown}
    fill="currentColor"
    aria-hidden="true"
  />
);

export const MoreToggle = ({ open, setOpen, ...props }) => {
  return (
    <span
      className="bg-light-gray rounded-sm ml-2 text-dark font-normal hover:bg-light-green cursor-pointer"
      onClick={() => setOpen(!open)}
      {...props}
    >
      <Icon open={open} /> {open ? "minder" : "meer..."}
    </span>
  );
};

export const More = ({ open, setOpen, ...props }) => (
  <div
    className="float-right bg-light-gray rounded-sm ml-2 text-dark font-normal hover:bg-light-green cursor-pointer"
    onClick={() => setOpen(!open)}
    {...props}
  >
    <Icon open={open} />
  </div>
);

export const MoreFold = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <More open={open} setOpen={setOpen} />{" "}
      {open && (
        <>
          <hr className="text-dark-gray border-dashed my-1" />
          {children}
        </>
      )}
    </>
  );
};
